const layout = () => import("../../external/layout.vue");
const cadaster = () => import("./cadaster.vue");

const cadasterRoutes = {
  path: "/cadaster",
  component: layout,
  children: [
    {
      path: "",
      name: "cadaster",
      component: cadaster,
    },
  ],
};

export default cadasterRoutes;